export const maxZoom = 18;
export const marginLeftMapaPainel = '400px';